// src/hooks/useApiEventHandler.js
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

const useApiEventHandler = () => {
  const navigate = useNavigate();

  const handleEvent = useCallback(
    (event) => {
      switch (event?.type) {
        case "NOT_FOUND":
          navigate(event.path || "/notFound");
          break;
        case "LOGOUT":
          navigate(event.path || "/login");
          break;
        default:
          break;
      }
    },
    [navigate]
  );

  return { handleEvent };
};

export default useApiEventHandler;
